import * as React from 'react';
import Box from '@mui/material/Box';

const Container = ({children}) => {

    return (

        <Box sx={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'center',
            width: '95%',
            marginBottom: 10
        }}>

            {children}

        </Box>

    );
};

export default Container;
